import type {
  CollectionActions,
  CollectionStateSlice,
} from '@freelancer/datastore/core';
import {
  mergeDocuments,
  transformIntoDocuments,
} from '@freelancer/datastore/core';
import { transformTrackingConsentMode } from './tracking-consent-mode.transformers';
import type { TrackingConsentModeCollection } from './tracking-consent-mode.types';

export function trackingConsentModeReducer(
  state: CollectionStateSlice<TrackingConsentModeCollection> = {},
  action: CollectionActions<TrackingConsentModeCollection>,
): CollectionStateSlice<TrackingConsentModeCollection> {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === 'trackingConsentMode') {
        const { result, ref, order } = action.payload;
        return mergeDocuments<TrackingConsentModeCollection>(
          state,
          transformIntoDocuments([result], transformTrackingConsentMode),
          order,
          ref,
        );
      }
      return state;
    }

    default:
      return state;
  }
}
